import React from 'react'
import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import { useOpenSlaConfigEditModal } from '../../../../utils/routes/modals/modalsActions'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import { Title, SmallText } from '../../../../packages/kiti/components/presentation/Text'
import Link from '../../../../components/actions/Link'
import IconText from '../../../../components/presentation/IconText'

const Header = () => {
  const openServiceOrderSlaEditModal = useOpenSlaConfigEditModal()
  const { t } = useTranslation('listSla')

  return (
    <Grid gap={0.6} align="center">
      <Col>
        <Icon name="RiTimerLine" color="dark3" size={1.5} />
      </Col>
      <Col>
        <Title size="h4" noMargin>
          {t('header.title')}
        </Title>
        <SmallText>{t('header.subtitle')}</SmallText>
      </Col>
      <Col flex={1} />
      <Col>
        <Link onClick={openServiceOrderSlaEditModal}>
          <IconText
            iconName="BsPlusCircleFill"
            label={t('header.newConfig')}
            size="small"
            right
            iconSize=".8rem"
            color={COLORS.purple}
            noWrap
          />
        </Link>
      </Col>
    </Grid>
  )
}

export default Header
